import _ from 'lodash';
import Immutable from 'seamless-immutable';

import { baseCollection, filter } from '../../common/collections';
import PublishingDestinationsModel from './publishing-destinations-model';

function deserialize(publishingDestinations) {
  return Immutable(_.map(publishingDestinations, PublishingDestinationsModel.deserialize));
}

/**
 * Filters a PublishingDestination Collection by there isPublished status
 * @param {PublishingDestination[]} publishingDestinations
 * @returns {PublishingDestination[]}
 */
function filterByIsPublished(publishingDestinations) {
  return filter((publishingDestination) => publishingDestination.displayContainer.isPublished, publishingDestinations);
}

export default {
  ...baseCollection,
  create: deserialize,
  deserialize,
  filterByIsPublished,
};
